module.exports = __webpack_public_path__ + "static/media/database.21e18c6a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/database.svg
// module id = 2188
// module chunks = 0